import { inject, provideEnvironmentInitializer } from '@angular/core';

import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

export function withFlagsTranslations() {
  return provideEnvironmentInitializer(() => {
    const controls = inject(CosFeatureFlagsToolbarControlsSet);
    controls.add(async () => {
      const { CosFeatureFlagsTranslationsControlComponent } = await import(
        './feature-flags-translations-control.component'
      );
      return CosFeatureFlagsTranslationsControlComponent;
    });
  });
}
